import React, { useContext, useState } from "react";
import { IssuesWrapper } from "@vp/gatsby-pages-issues-tracker-plugin";
import {
  BoundedContent,
  Icon,
  FlexBox,
  UncustomizableMarkup,
  Button,
  Link,
  ModalDialog,
  ModalDialogBody,
  ModalDialogCloseButton,
  ModalDialogContent,
  ModalDialogNav,
} from "@vp/swan";
import { Translations } from "../../utils/Translation";
import { isMailingServicesMpv } from "../../utils/mailingServicesUtil";
import MemoizedReactMarkdown from "../MemoizedReactMarkdown";
import TrackingUtil from "../../utils/tracking";
import { PageStaticDataContext } from "../../contexts/PageStaticDataContextProvider";

interface MailingServiceTermsOfUseProps {}

const MailingServiceTermsOfUse = (props: MailingServiceTermsOfUseProps) => {
  const { locale, mpv } = useContext(PageStaticDataContext);
  const { mpvId } = mpv;
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const termsOfUseCalloutEntry = Translations.getInstance().getTranslationEntry(
    "mailingServiceTermsOfUseCallout"
  );
  const termsOfUseContentEntry = Translations.getInstance().getTranslationEntry(
    "mailingServiceTermsOfUseContent"
  );

  if (!termsOfUseContentEntry || !isMailingServicesMpv(mpvId, locale)) {
    return <></>;
  }

  return (
    <BoundedContent>
      <IssuesWrapper
        targetNodes={[termsOfUseCalloutEntry]}
        elementName="Mailing service terms of use callout"
      >
        <FlexBox pl={"3"} flexDirection="row" alignItems="center">
          <Icon skin="standard" iconType="info" mr={"3"} />
          <Link
            render={p => (
              <Button
                skin="link"
                className={p.className}
                onClick={() => {
                  TrackingUtil.trackTermsOfUseToggle(true, mpvId);
                  setIsDialogOpen(true);
                }}
              >
                {p.children}
              </Button>
            )}
          >
            {termsOfUseCalloutEntry ?? ""}
          </Link>
        </FlexBox>
      </IssuesWrapper>
      <ModalDialog
        isOpen={isDialogOpen}
        onRequestDismiss={() => {
          TrackingUtil.trackTermsOfUseToggle(false, mpvId);
          setIsDialogOpen(false);
        }}
        variant="panel-right"
      >
        <ModalDialogContent>
          <ModalDialogNav>
            <ModalDialogCloseButton
              visuallyHiddenLabel={Translations.getInstance().getTranslation("dismissAlert")}
            />
          </ModalDialogNav>
          <ModalDialogBody>
            <IssuesWrapper
              targetNodes={[termsOfUseContentEntry]}
              elementName="Mailing service terms of use content"
            >
              <UncustomizableMarkup>
                <MemoizedReactMarkdown>{termsOfUseContentEntry}</MemoizedReactMarkdown>
              </UncustomizableMarkup>
            </IssuesWrapper>
          </ModalDialogBody>
        </ModalDialogContent>
      </ModalDialog>
    </BoundedContent>
  );
};

export default MailingServiceTermsOfUse;
